import { isAddress, isAddressEqual } from 'viem';

// Null-safe / garbage-safe Ethereum address equality (wraps viem's
// isAddressEqual, which throws on invalid input). Use it for all UI address
// comparisons where either side comes from a non-schema source — wagmi,
// user input, localStorage, raw backend strings — and may be checksummed,
// lowercased, partial, or absent. (Values already normalized to canonical
// EIP-55 form at a parse boundary could compare with ===; this helper is
// for everything that isn't.)
//
// Never throws: a missing side (null / undefined / '') or a string that
// isn't a 20-byte hex address → false. Comparison is hex-case-insensitive,
// and EIP-55 checksum validity is deliberately NOT enforced — checksummed,
// lowercased, and (checksum-invalid) uppercased forms of the same address
// all compare equal.
export function isSameAddress(
  a: string | null | undefined,
  b: string | null | undefined,
): boolean {
  // Stryker disable next-line ConditionalExpression, LogicalOperator: equivalent — viem's isAddress returns false (never throws) for null/undefined/'', so the isAddress guard below already yields false for any missing side; this line exists as the TS narrowing (string | null | undefined → string) plus a fast path.
  if (a == null || b == null) return false;
  if (!isAddress(a, { strict: false }) || !isAddress(b, { strict: false })) {
    return false;
  }
  return isAddressEqual(a, b);
}
